module.exports = __webpack_public_path__ + "static/logo-hemp-new-307d6c632b4e421d151d920f4f67266b.png";